const clean = (value) => String(value ?? '').trim();

const collectUniqueMessages = (items = [], limit = 3) => {
  const out = [];
  const seen = new Set();
  for (const item of items || []) {
    const message = clean(item?.message);
    if (!message || seen.has(message)) continue;
    seen.add(message);
    out.push(message);
    if (out.length >= Math.max(1, Number(limit) || 3)) break;
  }
  return out;
};

export const getPublishPreflightMessages = (result, type = 'blockers', limit = 3) => (
  collectUniqueMessages(result?.[type] || [], limit)
);

export const getPublishPreflightBlockMessage = (result, fallback = '发布前检查未通过') => {
  const messages = getPublishPreflightMessages(result, 'blockers', 3);
  if (messages.length === 0) return fallback;
  const total = Array.isArray(result?.blockers) ? result.blockers.length : messages.length;
  const extra = total > messages.length ? ` 等 ${total - messages.length} 项问题` : '';
  return `发布前检查未通过：${messages.join('；')}${extra}`;
};

export const getPublishPreflightWarningMessage = (result, fallback = '当前存在待处理风险') => {
  const messages = getPublishPreflightMessages(result, 'warnings', 3);
  if (messages.length === 0) return fallback;
  const total = Array.isArray(result?.warnings) ? result.warnings.length : messages.length;
  const extra = total > messages.length ? ` 等 ${total - messages.length} 项提醒` : '';
  return `当前存在待处理风险：${messages.join('；')}${extra}`;
};

